import { useCallback, useEffect } from 'react';
import { debounce } from '@at/event-utils/lib/debounce-utils/debounce.util';
import { useDebouncedState } from './use-debounced-state.hook';
/** Get size width of an element - debounced */
export var useElementWidth = function (_a) {
    var elementRef = _a.elementRef, resizeTarget = _a.resizeTarget, _b = _a.debounceTime, debounceTime = _b === void 0 ? 200 : _b, minWidthForClickableCarousel = _a.minWidthForClickableCarousel;
    var _c = useDebouncedState(undefined, debounceTime), elementWidth = _c[1], setElementWidth = _c[2];
    var setElementSize = useCallback(function () {
        var _a;
        var windowInnerWidth = window.innerWidth;
        var width = resizeTarget === 'window' && windowInnerWidth < minWidthForClickableCarousel
            ? windowInnerWidth
            : (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth;
        if (!width)
            return;
        if (width === elementWidth)
            return;
        setElementWidth(width);
    }, [elementRef, resizeTarget, minWidthForClickableCarousel, elementWidth, setElementWidth]);
    useEffect(function () {
        setElementSize();
        // eslint-disable-next-line react-hooks/exhaustive-deps -- first run on mount
    }, []);
    useEffect(function () {
        var debouncedSetElementSize = debounce(function () { return setElementSize(); }, debounceTime, true);
        window.addEventListener('resize', debouncedSetElementSize, { passive: true });
        return function () {
            window.removeEventListener('resize', debouncedSetElementSize);
        };
    }, [debounceTime, setElementSize]);
    return elementWidth;
};
